export default "__VITE_ASSET__BcJkiEuf__"